import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import styles from '../BookingWidget.module.css';

const emailSchema = z.object({
  email: z.string().trim().email('Bitte gültige E-Mail eingeben'),
});

type EmailFormValues = z.infer<typeof emailSchema>;

interface RedeemEmailStepProps {
  onSubmit: (email: string) => void;
  isSubmitting: boolean;
  serverError: string | null;
  infoMessage: string | null;
}

export function RedeemEmailStep({
  onSubmit,
  isSubmitting,
  serverError,
  infoMessage,
}: RedeemEmailStepProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<EmailFormValues>({
    resolver: zodResolver(emailSchema),
    defaultValues: { email: '' },
    mode: 'onSubmit',
  });

  return (
    <form
      id="yoga-redeem-email-form"
      className={styles.form}
      onSubmit={handleSubmit((values) => onSubmit(values.email.trim().toLowerCase()))}
      noValidate
    >
      {serverError ? <p className={styles.error}>{serverError}</p> : null}
      {infoMessage ? <p className={styles.info}>{infoMessage}</p> : null}

      <div className={styles.field}>
        <label className={styles.label} htmlFor="redeemEmail">
          E-Mail
        </label>
        <input
          id="redeemEmail"
          className={styles.input}
          type="email"
          autoComplete="email"
          disabled={isSubmitting}
          {...register('email')}
        />
        {errors.email ? (
          <span className={styles.fieldError}>{errors.email.message}</span>
        ) : null}
      </div>
    </form>
  );
}
